<template>
  <div v-if="device && device_type">
    <k-layout row>
      <k-flex c6>
        <k-text-field label="Comment" hide-details v-model="device_log.meta.comment"></k-text-field>
        </k-flex>
      <k-flex c3>
        <select-content-list :clearable="false" hide-details label="Status" :list_id="device_type.value.status_list_id" v-model="device.status_id" item-value="id" item-text="name"></select-content-list>
      </k-flex>
      <k-flex c3>
        <select-content-list :clearable="false" hide-details label="Location" :list_id="device_type.value.location_list_id" v-model="device.location_id" item-value="id" item-text="name"></select-content-list>
      </k-flex>
    </k-layout>
  </div>
</template>


<script>
import * as FormItems from '@/components/form_items'
import SettingsModel from '@/models/settings.js';
import SelectContentList from '@/components/SelectContentList'

export default {
  props: ["id"],

  data () {
    var ch = this.$cloudserver.channel("devices:"+(this.id||"create"));
    return {
      ws_channel: ch,
      device: this.convertDevice(ch.data),
      device_log: {meta: {}},
    }
  },
  components: {
    SelectContentList,
    ...FormItems
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.device = this.convertDevice(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        this.ws_channel = this.$cloudserver.channel("devices:"+(this.id||"create"));
        this.ws_channel.join();
      }
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    devices () {
      return Object.values(this.$store.state.devices);
    },
    devices_map () {
      return this.$store.state.devices;
    },
    device_types () {
      return SettingsModel.list("device_type");
    },
    device_type () {
      if (typeof(this.device.type) != "undefined") {
        return SettingsModel.get_by_name(this.device.type);
      }
      return undefined;
    },
    form () {
      return _.get(this.device_type, "value.form", []) || [];
    },
  },
  methods: {
    convertDevice (newVal, oldVal) {
      var device = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      if(typeof(device) == "undefined" || _.isEmpty(device)) return undefined;

      return device;
    },
    archive () {

    },
    reset () {
      this.device = this.convertDevice(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var device = _.cloneDeep(this.device);

        this.ws_channel.save({device: device, device_log: this.device_log})
          .then((msg) => {
            self.$message.success("Device log was created!");
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
            this.device_log.meta.comment = "";
          })
          .catch((msg) => {
            console.log(msg);
            self.$message.warning("Unable to create device log!");
          });
      }
    },
  }

}
</script>